var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-class"},[_c('h2',[_vm._v("INTEGRANTES")]),_c('TabelaEquipe',{staticClass:"tabela"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }